import React from "react";
import Modal from "../Modal";
import FormModal from "../FormModal";
import { useState } from "react";
import { Button } from "react-bootstrap";

const SupportModal = ({ user, showModal, setShowModal, espDomain }) => {
  if (user) {
    const [showModalUnlock, setShowModalUnlock] = useState(false);
    const [showModalPW, setShowModalPW] = useState(false);
    const [showModalResetPW, setShowModalResetPW] = useState(false);
    const [modalResetPWId, setModalResetPWId] = useState(null);

    const supportTitle = `Support ${user?.full_name}`;

    const hasEntityAccess = (userEntities) => {
      const statuses = Object.values(userEntities);

      return statuses.length > 0 && statuses.some((status) => status === "active");
    };

    function UnlockButton() {
      if (user.unlock_token) {
        return (
          <Button
            className="btn-sm btn-danger btn"
            onClick={() => {
              document.querySelectorAll(".modal-backdrop")[0].remove();
              document.querySelector("body").removeAttribute("style");
              setShowModal(false);
              setShowModalUnlock(true);
            }}
          >
            Unlock
          </Button>
        );
      }
    }

    return (
      <Modal
        show={showModal}
        title={supportTitle}
        modalId="support_modal"
        buttonText="Ok"
        buttonType="primary"
        action={() => setShowModal(false)}
        dismiss={() => setShowModal(false)}
        body={
          <div>
            {user.locked ? (
              <div className="alert alert-danger">
                <b>Account Locked</b>
                <p>This account was locked due to exceeding allowed login attempts.</p>
                <UnlockButton />
              </div>
            ) : null}
            {(() => {
              switch (user.registration_status) {
                case "pending_invite":
                  return (
                    <div className="alert alert-primary">
                      <b>Onboarding</b>
                      {hasEntityAccess(user.user_entities) ? (
                        <p>
                          This user has not yet used the onboarding flow. Send onboarding link in an
                          email to allow the user to register.
                        </p>
                      ) : (
                        <p>
                          This user has pending activation state and does not have access to any
                          CEs. When the user follows the onboarding link, they will only be able to
                          view the "No Covered Entity Access" page.
                        </p>
                      )}
                      <a
                        href={`/users/${user.id}/email_onboarding_link`}
                        className="btn btn-sm btn-primary"
                      >
                        Resend Onboarding Email
                      </a>
                      <hr />
                      <p>Or, share the following link.</p>
                      <div className="highlight bg-light mt-2 rounded border p-3">
                        <code className="text-muted user-select-all">
                          {user.onboarding_link}
                          {window.isSecureContext ? (
                            <div className="mt-2">
                              <button
                                className="btn btn-sm btn-secondary"
                                onClick={() => {
                                  navigator.clipboard.writeText(user.onboarding_link);
                                  alert("Copied!");
                                }}
                              >
                                Copy Link
                              </button>
                            </div>
                          ) : null}
                        </code>
                      </div>
                    </div>
                  );
                case "pending_email_verification":
                  return (
                    <div className="alert alert-primary">
                      <b>Onboarding</b>
                      <p>
                        User has registered (set email & password) but not verified their email.
                        Please prompt user to login to the platform via {espDomain}/login using
                        their login credentials.
                      </p>
                    </div>
                  );
                case "pending_all_entity_verification":
                  return (
                    <div className="alert alert-primary">
                      <p>
                        User has an active activation state but has a pending status for all
                        user-entities and, therefore, cannot view any data on the platform. Please
                        review this user's pending entity access on the "User Pending Entity Access"
                        page.
                      </p>
                    </div>
                  );
                case "pending_some_entity_verification":
                  return (
                    <div className="alert alert-primary">
                      <p>
                        User has full access to the platform but has some pending user-entity
                        access. Please review this user's pending entity access on the "User Pending
                        Entity Access" page.
                      </p>
                    </div>
                  );
                case "no_entity_access":
                  return (
                    <div className="alert alert-danger">
                      <p>
                        This user does not have access to any 340B IDs. Encourage the user to reach
                        out to the Entity Administrator to grant them access or have them provide
                        sufficient documentation to grant them access. Please do not provide entity
                        administrator information back to the user.
                      </p>
                    </div>
                  );
                case "full_platform_access":
                  return (
                    <div className="alert alert-success">
                      <p>User has full access to the platform. No action required.</p>
                      <hr />
                      <b>Reset Password:</b>
                      <p>Send an email to this user with a reset password link.</p>
                      <Button
                        className="btn-sm btn-success"
                        onClick={() => {
                          document.querySelectorAll(".modal-backdrop")[0].remove();
                          document.querySelector("body").removeAttribute("style");
                          setShowModal(false);
                          setShowModalResetPW(true);
                          setModalResetPWId(user.id);
                        }}
                      >
                        Send Reset Password Email
                      </Button>
                    </div>
                  );
                default:
                  return null;
              }
            })()}
            <React.Fragment>
              <FormModal
                show={showModalUnlock}
                title="Unlock User Account?"
                buttonText="Unlock"
                buttonType="primary"
                modalId={`unlock_modal_${user.id}`}
                fields={`Are you sure you want to unlock ${user?.full_name}'s account?`}
                action={`/users/${user.id}/unlock`}
                dismiss={() => {
                  setShowModalUnlock(false);
                }}
              />
              <FormModal
                show={showModalPW}
                title="Clear Password"
                buttonText="Clear Password"
                buttonType="danger"
                modalId={`clear_pw_modal_${user.id}`}
                fields={`Are you sure you want to clear ${user?.full_name}'s password?`}
                action={`/users/${user.id}/clear_password`}
                dismiss={() => {
                  setShowModalPW(false);
                }}
              />
              <FormModal
                show={showModalResetPW}
                title="Send Reset Password Email"
                buttonText="Send Reset Password Email"
                buttonType="success"
                modalId={`reset_pw_modal_${user.id}`}
                fields={`Are you sure you want to send a reset password email to ${user?.email}?`}
                action={`/users/${user.id}/reset_password`}
                dismiss={() => {
                  setShowModalResetPW(false);
                }}
              />
            </React.Fragment>
          </div>
        }
      />
    );
  }
};

export default SupportModal;
